import { Component } from '@angular/core';

@Component({
  selector: 'app-colaboraciones',
  standalone: true,
  templateUrl: './colaboraciones.html',
  styleUrl: './colaboraciones.scss',
})
export class ColaboracionesComponent {
  cards = [
    {
      title: 'Para Empresas',
      description: 'Talleres creativos de team building para fomentar la conexión y reducir el estrés en el equipo.',
    },
    {
      title: 'Para Eventos Privados',
      description: 'Una forma diferente de celebrar: crear, compartir y disfrutar en un espacio íntimo y cuidado.',
    },
    {
      title: 'Colaboraciones Creativas',
      description: 'Colaboramos con espacios y marcas para crear experiencias alineadas con la calma y la creatividad.',
    },
  ];

  scrollToContact() {
    const el = document.getElementById('contacto');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }
}
